const colors = {
  primary: "#2563EB",
  primary_dark: "#1F2937",
  primary_light: "#DBEAFE",

  secondary: "#6B7280",
  secondary_dark: "#374151",
  secondary_light: "#F3F4F6",

  lightBg: "#F8FAFC",
  darkBg: "#0F172A",

  success: "#14B8A6",
  success_dark: "#115E59",

  danger_dark: "#991B1B",
  danger: "#EF4444",
  danger_light: "#FECACA",

  warn: "#EAB308",
  warn_light: "#FEF9C3",

  border: "#E5E7EB",
};

export { colors };
